import React, { PropsWithChildren } from 'react';

import { logException } from '#/features/logging/logging';

interface Props
  extends PropsWithChildren<{ readonly fallback: React.ReactNode }> {}

interface State {
  readonly hasError: boolean;
}

export default class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error: Error) {
    return { hasError: true };
  }

  // eslint-disable-next-line class-methods-use-this
  override componentDidCatch(cause: Error, _info: React.ErrorInfo) {
    const error = new Error('App crashed', { cause });
    logException(error);
  }

  override render() {
    if (this.state.hasError) {
      return this.props.fallback;
    }
    return this.props.children;
  }
}
